<template>
    <div class="resultData_content">
        <div v-if="tables" style="overflow-x: auto;">
            <div style="min-width: 940px;">
                <v-data-table
                    v-model="selectedItem"
                    item-key="id"
                    :headers="headers"
                    :items="data1"
                    @click:row="goDetail"
                    show-select
                    disable-pagination
                    hide-default-footer
                    class="common_table"
                >
                    <template v-slot:item.title="{item}">
                        <div class="overflow2">
                            {{ item.title }}
                        </div>
                    </template>
                    <template v-slot:item.inventor="{item}">
                        <div class="overflow2">
                            <span v-for="(item1,index) in item.inventor" :key="index">{{item1}}</span>
                        </div>
                    </template>
                    <template v-slot:item.applicant="{item}">
                        <div class="overflow2">
                            <span v-for="(item1,index) in item.applicant" :key="index">{{item1}}</span>
                        </div>
                    </template>
                    <template v-slot:item.applicationDate="{item}">
                        <div class="overflow2" style="min-width: 86px;">
                            {{ item.applicationDate }}
                        </div>
                    </template>
                    <template v-slot:item.legalStatus="{item}">
                        <div class="overflow2" style="min-width: 64px;">
                            {{ item.legalStatus }}
                        </div>
                    </template>
                </v-data-table>
            </div>
        </div>
        <div v-if="imageText" class="imgtext_wrap">
            <div class="flex_style left top_nav_check">
                <v-checkbox
                    v-model="selAll"
                    :indeterminate="isIndeter"
                >
                </v-checkbox>
                <span class="check_text">选中本页</span>
            </div>
            <v-data-iterator
                :items="data2"
                item-key="id"
                @input="getSelectKeys"
                disable-pagination
                hide-default-footer
                >            
                <template v-slot:default="{items}"> 
                    <!-- ,isSelected, select -->
                    <!-- <v-card v-for="item in items" :key="item.id" class="item"> -->
                        <v-list dense>
                            <v-list-item-group
                            v-model="selectKeys"
                            multiple
                            color="primary"
                            >
                            <v-card v-for="item in items" :key="item.id" class="item">
                                <div class="icon">
                                    <v-list-item  :value="item.id" >
                                        <template v-slot:default="{active}">
                                                <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                        </template>
                                    </v-list-item>
                                </div>
                                <div class="center">
                                    <!-- @click="goDetail1(item.id)" -->
                                    <div class="lefts">
                                        <div class="img_icon" v-if="item.imagePath">
                                            <div class="img_bg">
                                                <img src="../../assets/images/icons/empty_icon.svg" alt="">
                                                <div class="text">该专利无附图</div>
                                            </div>
                                            <img class="img_url" :src="$store.state.baseUrl + item.imagePath" alt="">                                         
                                        </div>
                                        <div class="img_icon empty_icon" v-else>
                                            <img src="../../assets/images/icons/empty_icon.svg" alt="">
                                            <div class="text">该专利无附图</div>
                                        </div>
                                        <!-- <div class="img_icon" v-if="item.showSearchImage">
                                            <img :src="$store.state.imgSearch +'?key='+ item.showSearchImage" alt="">
                                        </div> -->
                                    </div>
                                    <div class="rights">
                                        <!-- <div class="num">{{item.documentNumber}}</div> -->
                                        <div class="text_wrapper mouse_default marb16Imp">
                                            <span class="tag_icon blue1" v-if="item.type=='发明公开'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.type}}</text-highlight><span v-else>{{item.type}}</span></span>
                                            <span class="tag_icon blue2" v-if="item.type=='发明授权'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.type}}</text-highlight><span v-else>{{item.type}}</span></span>
                                            <span class="tag_icon blue3" v-if="item.type=='实用新型'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.type}}</text-highlight><span v-else>{{item.type}}</span></span>
                                            <span class="tag_icon adj" v-if="item.type=='外观设计'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.type}}</text-highlight><span v-else>{{item.type}}</span></span>
                                            <!-- <div class="title hand" @click="goDetail1(item.id)" :title="item.title"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries || baz">{{item.title}}</text-highlight><span v-else>{{item.title}}</span></div> -->
                                        <div class="title hand" @click="goDetail1(item.id)" :title="item.title"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries || baz">{{item.title}}</text-highlight><span v-else>{{item.title}}</span></div>
                                                         

                                            <v-tooltip bottom content-class="lawInfo_pop_wrapper">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-bind="attrs" v-on="on" @mouseover="getInfo1(item.id)">
                                                        <span class="tag_icon type1 greens" v-if="item.legalStatus=='有效专利'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.legalStatus}}</text-highlight><span v-else>{{item.legalStatus}}</span></span>
                                                        <span class="tag_icon type1 yellow2" v-if="item.legalStatus=='公开'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.legalStatus}}</text-highlight><span v-else>{{item.legalStatus}}</span></span>
                                                        <span class="tag_icon type1 yellow1" v-if="item.legalStatus=='实质审查'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.legalStatus}}</text-highlight><span v-else>{{item.legalStatus}}</span></span>
                                                        <span class="tag_icon type1 grey" v-if="item.legalStatus=='失效专利' || item.legalStatus=='无效专利'"> <text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.legalStatus}}</text-highlight><span v-else>{{item.legalStatus}}</span></span>
                                                    </div>
                                                </template>
                                                <div class="content_center" v-if="!loading1">
                                                    <div class="tit">法律信息</div>
                                                    <div class="list_item" v-for="(item,index) in lawList" :key="index">
                                                        <div class="date_time">
                                                            <v-icon>mdi-history</v-icon>
                                                            <span class="time">{{item.executeDate}}</span>
                                                            <span>{{item.type}}</span>
                                                        </div>
                                                        <div class="cons" v-if="item.content">{{item.content}}</div>
                                                    </div>
                                                </div>
                                                <div class="content_center" v-else>
                                                    <v-overlay
                                                        :absolute="absolute"
                                                        :value="loading1"
                                                        >
                                                            <v-progress-circular
                                                                indeterminate
                                                                size="64"
                                                            ></v-progress-circular>
                                                            <div class="text_center">正在加载中...</div>
                                                    </v-overlay>
                                                </div>
                                            </v-tooltip>
                                           
                                        </div>
                                        <div class="line_style1">
                                            <div class="text_wrapper"><label class="text1">
                                                    申请号：</label><span class="value_text mouse_default">
                                            <text-highlight :queries="queries" :baz="baz"
                                               :highlightComponent="MyClickableComponent" 
                                             v-if="queries">{{item.applicationNumber}}</text-highlight>
                                             <span class="mouse_default" v-else>{{item.applicationNumber}}</span>
                                             </span></div>
                                            <div class="text_wrapper"><label class="text1">申请日：</label><span class="value_text mouse_default"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.applicationDate}}</text-highlight><span class="mouse_default" v-else>{{item.applicationDate}}</span></span></div>
                                        </div>
                                        <div class="line_style1">
                                            <div class="text_wrapper"><label class="text1">公开(公告)号：</label><span class="value_text mouse_default"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.documentNumber}}</text-highlight><span class="mouse_default" v-else>{{item.documentNumber}}</span></span></div>
                                            <div class="text_wrapper"><label class="text1">公开(公告)日：</label><span class="value_text mouse_default"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.documentDate}}</text-highlight><span class="mouse_default" v-else>{{item.documentDate}}</span></span></div>
                                        </div>   
                                        <!-- <div class="text_wrapper"><label class="text">申请日：</label><span class="mouse_default"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.applicationDate}}</text-highlight><span class="mouse_default" v-else>{{item.applicationDate}}</span></span></div> -->
                                        <div class="text_wrapper"><label class="text">申请人</label><span><i class="hand" v-for="item1 in item.applicant" :key="item1" @click="querySearch('ap:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span class="hand" v-else>{{item1}}</span></i></span></div>
                                         <div class="text_wrapper"><label class="text">专利权人</label><span><i class="hand" @click="querySearch('assignee:', item.assignee)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.assignee}}</text-highlight><span class="hand" v-else>{{item.assignee}}</span></i></span></div>
                                        <div class="text_wrapper"><label class="text">当前专利权人</label><span><i class="hand" v-for="item1 in item.currentAssigneeList" :key="item1" @click="querySearch('currentAssignee:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span class="hand" v-else>{{item1}}</span></i></span></div>
                                        <div class="text_wrapper" v-if="item.inventor"><label class="text">发明人：</label><span class="overflow1"><i class="hand" v-for="(item1,index) in item.inventor" :key="index" @click="querySearch('inv:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span class="hand" v-else>{{item1}}</span></i></span></div>
                                        <!-- <div class="text_wrapper" v-if="item.currentAssigneeList"><label class="text">当前申请人：</label><span class="overflow1"><i v-for="(item1,index) in item.currentAssigneeList" :key="index"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span v-else>{{item1}}</span></i></span></div> -->
                                        <!-- <div class="text_wrapper" v-if="item.assignee"><label class="text">专利权人：</label><i class="hand" v-for="item1 in item.assignee.split(',')" :key="item1"><span v-if="queries" @click="querySearch('assignee:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent">{{item1}}</text-highlight></span><span class="hand" v-else>{{item1}}</span></i></div> -->
                                        <!-- <div class="text_wrapper" v-if="item.currentAssignee"><label class="text">当前专利权人：</label><i class="hand" v-for="item1 in item.currentAssignee.split(',')" :key="item1"><span v-if="queries" @click="querySearch('currentAssignee:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent">{{item1}}</text-highlight></span><span class="hand" v-else>{{item1}}</span></i></div> -->
                                        <!-- <div class="text_wrapper"><label class="text">代理人：</label><span v-for="(item1,index) in item.agent" :key="index">{{item1}}</span></div> -->
                                        <!-- <div class="text_wrapper"><label class="text">代理机构：</label> <span>{{item.agency}}</span></div> -->
                                        <div class="text_wrapper" v-if="item.ipc"><label class="text" >IPC分类号：</label><span class="overflow1"> <i class="hand" v-for="(item1,index) in item.ipc" :key="index" @click="querySearch('ipc:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span class="hand" v-else>{{item1}}</span></i></span></div>
                                        <!-- <div class="text_wrapper" v-if="item.cpc"><label class="text">CPC分类号：</label><span class="overflow1"><i class="hand" v-for="(item1,index) in item.cpc" :key="index" @click="querySearch('cpc:', item1)"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item1}}</text-highlight><span class="hand" v-else>{{item1}}</span></i></span></div> -->
                                        <!-- <div class="text_wrapper"><label class="text">权利要求数：</label> <span>{{item.claimsCount}}</span></div> -->
                                        <div class="text_wrapper text_wrapper1" v-if="item.summary"><span class="summary_text overflow4 mouse_default"><text-highlight :queries="queries" :baz="baz" :highlightComponent="MyClickableComponent" v-if="queries">{{item.summary}}</text-highlight><span v-else>{{item.summary}}</span></span></div>
                                        <div class="result_list_btns">
                                            <div class="item" @click="addSpaceEvent(item)">加入工作空间</div>
                                            <div class="item" @click="pdfView(item.id)">PDF全文</div>
                                            <div class="item blue1" @click="getPdfFile(item.id)">PDF下载</div>
                                            <div class="item blue1" v-if="false">全文下载</div>
                                            <div class="item blue1" @click="zhulDown(item.id)">著录项下载</div>
                                            <div class="item" @click="goLike(item)">相似专利</div>
                                            <div class="item" @click="doubleSreen(item.id)">双屏查看</div>
                                            <div class="item" v-if="false">Global Dossier</div>
                                            <div class="item" v-if="false">Espacenet</div>
                                        </div>
                                        <div class="text_btns" v-if="false">
                                            <div class="titem" @click="zhulDown(item.id)">
                                                <div class="ticon zhulu"></div>
                                                <div class="tname">著录项下载</div>
                                            </div>
                                            <div class="titem" @click="getPdfFile(item.id)">
                                                <div class="ticon down"></div>
                                                <div class="tname">PDF下载</div>
                                            </div>
                                            <div class="titem" @click="pdfView(item.id)">
                                                <div class="ticon view"></div>
                                                <div class="tname">PDF查看</div>
                                            </div>
                                            <div class="titem" @click="doubleSreen(item.id)">
                                                <div class="ticon double"></div>
                                                <div class="tname">双屏查看</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                            </v-list-item-group>
                        </v-list>
                    <!-- </v-card> -->
                </template> 
            </v-data-iterator>
        </div>
        <div v-if="fullText">
            <div class="imgtext_wrap">
                <div class="flex_style left top_nav_check"> 
                    <v-checkbox
                        v-model="selAll"
                        :indeterminate="isIndeter"
                    >
                    </v-checkbox>
                    <span class="check_text">选中本页</span>
                </div>
                <v-list class="patent_list">
                    <v-list-item-group
                        v-model="selectKeys"
                        multiple
                        color="primary"
                        >
                        <v-row class="item_wrapper1"> 
                            <v-col xs="12" sm="12" md="4" lg="3" xl="2" v-for="(item,index) in data3" :key="index">
                                <div class="item_box">
                                    <v-list-item :value="item.id" class="icon">
                                        <template v-slot:default="{active}">
                                            <!-- <v-list-item-content  :title="item.title"> -->
                                                <v-checkbox :input-value="active"  color="primary"></v-checkbox>  
                                            <!-- </v-list-item-content> -->
                                        </template>
                                    </v-list-item>
                                    <v-tooltip bottom content-class="pop_wrapper" nudge-top="50">
                                        <template v-slot:activator="{ on, attrs }">                                                                  
                                        <div class="content hand" @click="goDetail1(item.id)" v-bind="attrs" v-on="on">
                                            <div class="img" v-if="!item.showSearchImage" :style="{'background': 'url('+$store.state.baseUrl + item.imagePath+') no-repeat center','background-size': 'contain'}">
                                                <!-- <img :src="$store.state.baseUrl + item.imagePath" alt=""> -->
                                            </div>
                                            <div class="img" v-if="item.showSearchImage" :style="{'background': 'url('+$store.state.imgSearch +'?key='+ item.showSearchImage+') no-repeat center','background-size': 'contain'}">
                                            </div>
                                            <div class="text">
                                                {{item.documentNumber}}
                                            </div>
                                            <div class="text">
                                                {{item.title}}
                                            </div>
                                        </div>
                                        </template>
                                        <div class="pop_content_wrapper">
                                            <div class="line_style">
                                                <span class="label">{{item.id}}</span>
                                                <span class="tag_wrapper">
                                                    <span class="tag_icon green" v-if="item.legalStatus=='有效专利'">{{item.legalStatus}}</span>
                                                    <span class="tag_icon yellow" v-if="item.legalStatus=='公开'|| item.legalStatus=='实质审查'"> {{item.legalStatus}}</span>
                                                    <span class="tag_icon grey" v-if="item.legalStatus=='失效专利' || item.legalStatus=='无效专利'"> {{item.legalStatus}}</span>
                                                    <span class="tag_icon blue1" v-if="item.type=='发明公开'"> {{item.type}}</span>
                                                    <span class="tag_icon green1" v-if="item.type=='发明授权'">{{item.type}}</span>
                                                    <span class="tag_icon orange" v-if="item.type=='实用新型'"> {{item.type}}</span>
                                                    <span class="tag_icon adj" v-if="item.type=='外观设计'">{{item.type}}</span>
                                                </span>
                                            </div>
                                            <div class="line_style">
                                                <span class="label">标题：</span>
                                                <span class="value">{{item.title}}</span>
                                            </div>
                                             <div class="line_style">
                                                <span class="label">公开(公告)号：</span>
                                                <span class="value">{{item.documentNumber}}</span>
                                            </div>
                                             <div class="line_style">
                                                <span class="label">申请号：</span>
                                                <span class="value">{{item.applicationNumber}}</span>
                                            </div>
                                             <div class="line_style">
                                                <span class="label">申请日：</span>
                                                <span class="value">{{item.applicationDate}}</span>
                                            </div>
                                             <div class="line_style">
                                                <span class="label">IPC分类号：</span>
                                                <span class="value"><i v-for="(item1,index) in item.ipc" :key="index">{{item1}}</i></span>
                                            </div>
                                             <div class="line_style">
                                                <span class="label">摘要：</span>
                                                <span class="value">{{item.summary}}</span>
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>
                            </v-col>
                        </v-row>
                    </v-list-item-group>
                </v-list>
            </div>
        </div>
        <div v-if="false">
            <div class="imgtext_wrap fulltext_wrap">
                <v-row>
                    <v-col md="3">公开（公告）号</v-col>
                    <v-col md="5">标题</v-col>
                    <v-col md="2">当前申请（专利权）人</v-col>
                    <v-col md="2">申请日</v-col>
                </v-row>
                <div v-for="(item,index) in data" :key="index" class="item">
                    <v-row @click="goDetail1(item.id)">
                        <v-col md="3" class="tit_overflow">（{{index+1}}） {{item.applicationNumber}}</v-col>
                        <v-col md="5" class="tit_overflow" :title="item.title">{{item.title}}</v-col>
                        <v-col md="2" class="tit_overflow" :title="item.applicant">{{item.applicant[0]}}</v-col>
                        <v-col md="2" class="tit_overflow" :title="item.applicationDate">{{item.applicationDate}}</v-col>
                    </v-row>
                   <v-row>
                       <v-col sm="12" md="12">
                       </v-col>
                   </v-row>
                </div>
            </div>
        </div>
       <!-- 选中列表 -->
       <div :class="{'tableSel_fix':true,'sm': isCollpse}" v-if="isShow&&selectKeys.length>0">
            <div class="flex_style betw fix_top_wrapper">
                <span>选中({{selectKeys.length}})</span>
                <span class="icon" v-if="!isCollpse" @click="isCollpse=!isCollpse"><v-icon>mdi-chevron-double-right</v-icon></span>
                <span class="icon" v-if="isCollpse" @click="isCollpse=!isCollpse"><v-icon>mdi-chevron-double-left</v-icon></span>
            </div>
            <div class="fix_center_wrapper" v-if="!isCollpse">
                <div class="tableSel_btn">
                    <span @click="zhuluDown">著录项下载</span>
                    <span @click="pdfDown">PDF下载</span>
                    <span class="marnone" @click="compare">对比</span>
                    <span class="line_vertial"></span>
                    <span class="clear" @click="clearSeleted">清空</span>
                </div>
                <div class="tableSel_list">
                    <div class="flex_style betw line" v-for="(item,index) in tempItem" :key="index">
                        <span class="text tit_overflow"><span class="label">{{item.id}} </span> {{item.title}}</span>
                        <span @click="delSelected(index)" class="del_btn"><span class="icon"></span></span>
                    </div>
                </div>
            </div>
       </div>
        <v-dialog v-model="pdfDialog" width="30%">
            <v-card class="country_dialog">
                <v-card-title class="headline lighten-2">PDF全文下载 <v-icon @click="handlepdfCancel">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper">
                        <div class="part_title">专利范围</div>
                        <div class="radio_part">
                            <v-radio-group v-model="scopeType">
                                <div class="radio_item">
                                    <v-radio
                                        label="选中文件"
                                        value="0"
                                    ></v-radio>
                                </div>
                                <div class="radio_item">
                                    <v-radio
                                        label="选择范围"
                                        value="1"
                                    ></v-radio>
                                    <div class="input_width">
                                        <v-text-field
                                            hide-details
                                            outlined
                                            placeholder="1-10,最多一次下载100条"
                                            v-model="pdfRange"
                                        ></v-text-field>
                                    </div>
                                </div>
                            </v-radio-group>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    @click="handlepdfCancel">
                    取消
                    </v-btn>
                    <v-btn
                    color="primary"
                    @click="handlepdfOk">
                    下载
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="pdfProgress" width="50%">
            <v-card>
                <v-card-title>下载进度</v-card-title>
                <v-card-text>
                    <div>
                        <v-progress-linear
                        v-model="proNum"
                        color="blue-grey"
                        height="25"
                        >
                        <template v-slot:default="{ value }">
                            <strong>{{ Math.ceil(value) }}%</strong>
                        </template>
                        </v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="zlDialog" width="600">
            <v-card class="country_dialog">
                <v-card-title class="headline lighten-2">下载著录项 <v-icon @click="handlezlCancel">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper">
                        <div class="part_title" v-if="!single">选择专利范围</div>
                        <div class="radio_part" v-if="!single">
                            <v-radio-group v-model="pdfRangeKey">
                                <div class="radio_item zhulu">
                                    <v-radio
                                        label="选中文件"
                                        value="0"
                                    ></v-radio>
                                </div>
                                <div class="radio_item">
                                    <v-radio
                                        label=""
                                        value="1">
                                        <template v-slot:label>
                                            <div class="flex_style left">
                                                <span class="text f1">范围从</span>
                                                <div class="w80p">
                                                    <v-text-field
                                                    hide-details
                                                    outlined
                                                    v-model="zlRange.r1">
                                                    </v-text-field>
                                                </div>
                                                <span class="text">至</span>
                                                <div class="w80p">
                                                    <v-text-field
                                                    hide-details
                                                    outlined
                                                    v-model="zlRange.r2">
                                                    </v-text-field>
                                                </div>
                                                <span class="text">条 <i class="f2">（一次性最多下载10000条）</i> </span>
                                            </div>
                                        </template>
                                    </v-radio>
                                </div>
                            </v-radio-group>
                        </div>
                        <div class="part_title">选择文件格式</div>
                        <div class="line_item">
                            <div class="flex_style left">
                                <span class="label">文件格式</span>
                                <span :class="{'icons excel':true,'active': formatKey=='0'}" @click="formatKey=0"></span>
                                <span :class="{'icons word':true,'active': formatKey=='1'}" @click="formatKey=1"></span>
                                <span :class="{'icons ppt':true,'active': formatKey=='2'}" @click="formatKey=2"></span>
                            </div>
                        </div>
                        <div class="part_title">选择导出内容</div>
                        <div class="line_item">
                            <div class="flex_style left margbsm">
                                <!-- <span class="label_item">请选择下载内容</span> -->
                                <div class="common_input_style">
                                    <v-select
                                    :items="sItems"
                                    item-text="text"
                                    v-model="zlKey"
                                    item-value="value"
                                    label=""
                                    outlined>
                                    </v-select>
                                </div>
                                <!-- <v-btn>新增自定义模版</v-btn> -->
                            </div>
                            <div class="textare_item" v-if="zlContent">
                                <span v-if="zlKey == '1'">基本字段：</span>
                                <span v-if="zlKey == '2'">常用字段：</span>
                                {{zlContent}}
                            </div>
                            <div class="flex_style left margbsm" v-if="false">
                                <span class="label_item">导出字段</span>
                                <v-textarea
                                outlined
                                name="input-7-4"
                                label=""
                                disabled
                                :value="zlContent"
                                ></v-textarea>
                            </div>
                            <div class="flex_style left">
                                <span class="part_title marb0">同时下载PDF全文</span>
                                <div class="switch_style">
                                    <v-switch
                                    v-model="switch1"
                                    inset
                                    ></v-switch>
                                    <!-- :label="switchName" -->
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    @click="handlezlCancel">
                    取消
                    </v-btn>
                    <v-btn
                    color="primary"
                    @click="handlezlOk">
                    下载
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="compDialog" width="90%" :fullscreen="fullscreen">
            <v-card class="compare_dialog">
                <v-card-title class="lighten-2">
                    <div class="headline">对比</div>
                    <div class="flex_style left">
                        <v-icon v-if="!fullscreen" @click="fullscreen=true">mdi-fullscreen</v-icon>
                        <v-icon v-if="fullscreen" @click="fullscreen=false">mdi-fullscreen-exit</v-icon>
                        <v-icon class="marl10" @click="compDialog= false">mdi-close</v-icon>
                    </div>  
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="full">
                    <div class="addSpace_wrapper padTop">
                        <div class="flex_style2">
                            <div class="w48 compare_item">
                                <div class="flex_style betw">
                                    <div class="common_input_style">
                                        <v-text-field
                                            v-model="compareName"
                                            label=""
                                            outlined
                                            :dense="true"
                                             @keydown.enter="initNumber"
                                            placeholder="搜索公开公告号"
                                        ></v-text-field>
                                    </div>
                                    <div class="common_input_style max280">
                                        <v-select
                                            :items="tempItem"
                                            item-text="title"
                                            item-value="id"
                                            label=""
                                            v-model="id"
                                            hide-details="true"
                                            @change="selChange"
                                            outlined>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="h84">
                                    <v-tabs v-model="activeKey" @change="activeChange" show-arrows>
                                        <v-tab key="1">基本信息</v-tab>
                                        <v-tab key="2">权利要求</v-tab>
                                        <v-tab key="3">说明书全文</v-tab>
                                        <v-tab key="4">PDF全文</v-tab>
                                        <v-tab key="5">法律信息</v-tab>
                                        <v-tab-item key="1">
                                            <div class="tabs_content maxHeight baseInfo">
                                                <div class="img_icon hand">
                                                    <img :src="$store.state.baseUrl + detailInfo.bigImagePath" alt="">
                                                </div>
                                                <h3 class="margbsm">专利基本信息</h3>
                                                <v-row>
                                                    <v-col sm="3">申请号</v-col>
                                                    <v-col sm="9">{{detailInfo.applicationNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">申请日</v-col>
                                                    <v-col sm="9">{{detailInfo.applicationDate}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">公开（公告）号</v-col>
                                                    <v-col sm="9">{{detailInfo.documentNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">公开（公告）日</v-col>
                                                    <v-col sm="9">{{detailInfo.documentDate}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">授权日</v-col>
                                                    <v-col sm="9">{{detailInfo.applicationNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">当前申请（专利权）人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo.applicant" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">第一申请（专利权）人</v-col>
                                                    <v-col sm="9">{{detailInfo.firstApplicant}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">发明人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo.inventor" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">第一发明人</v-col>
                                                    <v-col sm="9">{{detailInfo.firstInventor}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">IPC分类号</v-col>
                                                    <v-col sm="9">{{detailInfo.mainIpc}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">申请地址</v-col>
                                                    <v-col sm="9">{{detailInfo.applicantAddress}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">代理人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo.agent" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">代理机构</v-col>
                                                    <v-col sm="9">{{detailInfo.agency}}</v-col>
                                                </v-row>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="2">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in claimsInfo.split('。')" :key="index">
                                                    <p v-if="item">{{item}}。</p>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="3">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in despInfo.split('。')" :key="index">
                                                    <p v-if="item">{{item}}。</p>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="4">
                                            <div class="tabs_content maxHeight">
                                                <div style="height: 100%;">
                                                    <embed
                                                        :src="src2"
                                                        type="application/pdf"
                                                        width="100%"
                                                        height="100%"
                                                        />
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="5">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in transList" :key="index">
                                                    <div class="borderd margbsm">
                                                        <div>
                                                            <p>{{item.executeDate}}</p>
                                                            <p>{{item.type}}</p>
                                                            <p v-html="item.content"></p>
                                                            <p v-html="item.htmlContent"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                    </v-tabs>
                                </div>
                            </div>
                            <div class="line_style"></div>
                            <div class="w48 compare_item">
                                <div class="flex_style betw">
                                    <div class="common_input_style">
                                        <v-text-field
                                            v-model="compareName1"
                                            label=""
                                            outlined
                                            :dense="true"
                                            @keydown.enter="initNumber1"
                                            placeholder="搜索公开公告号"
                                        ></v-text-field>
                                    </div>
                                    <div class="common_input_style max280">
                                        <!-- selectedItem  -->
                                        <v-select
                                            :items="tempItem"
                                            item-text="title"
                                            item-value="id"
                                            label=""
                                            v-model="id1"
                                            hide-details="true"
                                            @change="selChange1"
                                            outlined>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="h84">
                                    <v-tabs  v-model="activeKey1" @change="activeChange1" show-arrows>
                                        <v-tab key="1">基本信息</v-tab>
                                        <v-tab key="2">权利要求</v-tab>
                                        <v-tab key="3">说明书全文</v-tab>
                                        <v-tab key="4">PDF全文</v-tab>
                                        <v-tab key="5">法律信息</v-tab>
                                        <v-tab-item key="1">
                                            <div class="tabs_content maxHeight baseInfo">
                                                <div class="img_icon hand">
                                                    <img :src="$store.state.baseUrl + detailInfo1.bigImagePath" alt="">
                                                </div>
                                                <h3 class="margbsm">专利基本信息</h3>
                                                <v-row>
                                                    <v-col sm="3">申请号</v-col>
                                                    <v-col sm="9">{{detailInfo1.applicationNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">申请日</v-col>
                                                    <v-col sm="9">{{detailInfo1.applicationDate}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">公开（公告）号</v-col>
                                                    <v-col sm="9">{{detailInfo1.documentNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">公开（公告）日</v-col>
                                                    <v-col sm="9">{{detailInfo1.documentDate}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">授权日</v-col>
                                                    <v-col sm="9">{{detailInfo1.applicationNumber}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">当前申请（专利权）人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo1.applicant" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">第一申请（专利权）人</v-col>
                                                    <v-col sm="9">{{detailInfo1.firstApplicant}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">发明人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo1.inventor" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">第一发明人</v-col>
                                                    <v-col sm="9">{{detailInfo1.firstInventor}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">IPC分类号</v-col>
                                                    <v-col sm="9">{{detailInfo1.mainIpc}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">申请地址</v-col>
                                                    <v-col sm="9">{{detailInfo1.applicantAddress}}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">代理人</v-col>
                                                    <v-col sm="9">
                                                        <span v-for="(item,index) in detailInfo1.agent" :key="index">
                                                            {{item}}
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col sm="3">代理机构</v-col>
                                                    <v-col sm="9">{{detailInfo1.agency}}</v-col>
                                                </v-row>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="2">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in claimsInfo1.split('。')" :key="index">
                                                    <p v-if="item">{{item}}。</p>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="3">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in despInfo1.split('。')" :key="index">
                                                    <p v-if="item">{{item}}。</p>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="4">
                                            <div class="tabs_content maxHeight">
                                                <div style="height: 100%;">
                                                    <embed
                                                        :src="src3"
                                                        type="application/pdf"
                                                        width="100%"
                                                        height="100%"
                                                        />
                                                </div>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item key="5">
                                            <div class="tabs_content maxHeight">
                                                <div v-for="(item,index) in transList1" :key="index">
                                                   <div class="borderd margbsm">
                                                        <div>
                                                            <p>{{item.executeDate}}</p>
                                                            <p>{{item.type}}</p>
                                                            <p v-html="item.content"></p>
                                                            <p v-html="item.htmlContent"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                    </v-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
            </v-card>
        </v-dialog>
         <v-dialog v-model="visible" width="80%">
            <div class="pdf_wrapper">
                <!-- <div class="tit">PDF全文</div> -->
                <v-card>
                    <v-card-title>PDF全文 <v-icon @click="visible=false">mdi-close</v-icon></v-card-title>
                    <v-card-text>
                        <div style="height: 100%;">
                            <embed
                                :src="src"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </div>
        </v-dialog>
        <v-dialog v-model="visible1" width="90%" :fullscreen="fullscreen1">
            <v-card class="compare_dialog">
                <div class="flex_style right padsm">
                    <v-icon v-if="!fullscreen1" @click="fullscreen1=true">mdi-fullscreen</v-icon>
                    <v-icon v-if="fullscreen1" @click="fullscreen1=false">mdi-fullscreen-exit</v-icon>
                    <v-icon class="marl10" @click="visible1= false">mdi-close</v-icon>
                </div>
                <v-card-text class="full">
                    <v-row>
                        <v-col sm="6" class="border-right">
                            <v-row class="detail_content1 common_tabs">
                                <v-col sm="12" class="detail_col">
                                        <v-tabs :show-arrows="true" @change="handleChange1">
                                            <v-tab key="1" @click="getDetail1(this.doubleId)">基本信息</v-tab>
                                            <v-tab key="2">摘要</v-tab>
                                            <v-tab key="3">权利要求</v-tab>
                                            <v-tab key="4">说明书</v-tab>
                                            <v-tab key="5">PDF全文</v-tab>
                                            <v-tab key="6">法律信息</v-tab>
                                            <v-tab-item key="1">
                                                <div class="tabs_content left">
                                                    <h3 class="margbsm">专利基本信息</h3>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.documentNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.documentDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">授权日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">当前申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.applicant" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.firstApplicant}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">发明人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.inventor" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一发明人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.firstInventor}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">IPC分类号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.mainIpc}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请地址</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicantAddress}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.agent" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理机构</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.agency}}</v-col>
                                                    </v-row>
                                                    <v-row v-if="false">
                                                        <v-col sm="3">摘要</v-col>
                                                        <v-col sm="9">{{detailInfo2.summary}}</v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="2">
                                                <div class="tabs_content left">
                                                    <h3 class="margbsm">专利摘要</h3>
                                                    <v-row>
                                                        <v-col sm="12" v-if="detailInfo2.summary">
                                                            <div v-for="(item,index) in detailInfo2.summary.split('。')" :key="index">
                                                                <p v-if="item">{{item}}。</p>
                                                            </div>
                                                        </v-col>
                                                        <v-col sm="12" v-else>
                                                            <span>暂无数据</span>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="3">
                                                <div class="tabs_content left" v-if="claimsInfo3">
                                                    <h3 class="margbsm">专利权利要求书</h3>
                                                    <div v-for="(item,index) in claimsInfo3.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="4">
                                                <div class="tabs_content left" v-if="despInfo2">
                                                    <h3 class="margbsm">专利说明书</h3>
                                                    <div v-for="(item,index) in despInfo2.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="5">
                                                <div class="tabs_content left">
                                                    <div style="height: 100%;">
                                                        <embed
                                                            :src="src"
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="100%"
                                                            />
                                                    </div>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="6">
                                                <div class="tabs_content left">
                                                    <v-data-table
                                                        item-key="id"
                                                        :headers="transHeader"
                                                        :items="transList2"
                                                        class="elevation-1"
                                                        :loading="loading"
                                                    >
                                                    </v-data-table>
                                                </div>
                                            </v-tab-item>
                                        </v-tabs>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col sm="6">
                            <v-row class="detail_content1 right common_tabs">
                                <v-col sm="12" class="detail_col">
                                        <v-tabs :show-arrows="true" @change="handleChange1">
                                            <v-tab key="1" @click="getDetail1(this.doubleId)">基本信息</v-tab>
                                            <v-tab key="2">摘要</v-tab>
                                            <v-tab key="3">权利要求</v-tab>
                                            <v-tab key="4">说明书</v-tab>
                                            <v-tab key="5">PDF全文</v-tab>
                                            <v-tab key="6">法律信息</v-tab>
                                            <v-tab-item key="1">
                                                <div class="tabs_content right">
                                                    <h3 class="margbsm">专利基本信息</h3>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.documentNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.documentDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">授权日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">当前申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.applicant" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.firstApplicant}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">发明人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.inventor" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一发明人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.firstInventor}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">IPC分类号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.mainIpc}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请地址</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.applicantAddress}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo2.agent" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理机构</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo2.agency}}</v-col>
                                                    </v-row>
                                                    <v-row v-if="false">
                                                        <v-col sm="3">摘要</v-col>
                                                        <v-col sm="9">{{detailInfo2.summary}}</v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="2">
                                                <div class="tabs_content right">
                                                    <h3 class="margbsm">专利摘要</h3>
                                                    <v-row>
                                                        <v-col sm="12" v-if="detailInfo2.summary">
                                                            <div v-for="(item,index) in detailInfo2.summary.split('。')" :key="index">
                                                                <p v-if="item">{{item}}。</p>
                                                            </div>
                                                        </v-col>
                                                        <v-col sm="12" v-else>
                                                            <span>暂无数据</span>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="3">
                                                <div class="tabs_content right" v-if="claimsInfo3">
                                                    <h3 class="margbsm">专利权利要求书</h3>
                                                    <div v-for="(item,index) in claimsInfo3.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="4">
                                                <div class="tabs_content right" v-if="despInfo2">
                                                    <h3 class="margbsm">专利说明书</h3>
                                                    <div v-for="(item,index) in despInfo2.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="5">
                                                <div class="tabs_content left">
                                                    <div style="height: 100%;">
                                                        <embed
                                                            :src="src"
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="100%"
                                                            />
                                                    </div>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="6">
                                                <div class="tabs_content left">
                                                    <v-data-table
                                                        item-key="id"
                                                        :headers="transHeader"
                                                        :items="transList2"
                                                        :loading="loading"
                                                        class="elevation-1"
                                                    >
                                                    </v-data-table>
                                                </div>
                                            </v-tab-item>
                                        </v-tabs>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import MyClickableComponent from '@/components/side/highlight.vue'
const formLayout = {
    labelCol: { span: 6,md:4,lg:2 },
    wrapperCol: { span:6,md:8,lg:10},
};
export default {
    props: ['showList','result','allFilter','queries','baz'],
    data() {
        return {
            formLayout,
            MyClickableComponent,
            fullscreen: false,
            compDialog: false,
            ids: [],
            isIndeter: false,
            selAll: false,
            selectedItem: [],
            singleSelect: false,
            tables: true,
            imageText: false,
            fullText: false,
            pageSize: 10,
            total: 0,
            length: 2,
            page: 1,
            desp: '',
            selectKeys: [],
            isSelectable: true,
            isCollpse: false,
            headers: [
                {
                    text: '公开（公告）号',
                    align: 'start',
                    sortable: false,
                    value: 'documentNumber'
                },
                {
                    text: '标题',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: '法律状态/事件',
                    align: 'start',
                    sortable: false,
                    value: 'legalStatus'
                },
                {
                    text: '申请人',
                    align: 'start',
                    sortable: false,
                    value: 'applicant'
                },
                // {
                //     text: '发明人',
                //     align: 'start',
                //     sortable: false,
                //     value: 'inventor'
                // },
                {
                    text: '申请日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
            ],
            data: [],
            data1: [],
            data2: [],
            data3: [],
            seltedPatent: [],
            pdfDialog: false,
            pdfProgress: false,
            zlDialog: false,
            pdfRangeKey: '',
            scopeType: 0,
            pdfRange: '1-10',
            zlRange: {
                r1: '',
                r2: ''
            },
            zlKey: '',
            formatKey: 0,
            sItems: [
                {
                    text: '基本字段',
                    value: '1'
                },
                {
                    text: '常用字段',
                    value: '2'
                }
            ],
            zlContent: '',
            compareName: '',
            compareName1: '',
            activeKey: '1',
            activeKey1: '1',
            detailInfo: {},
            detailInfo1: {},
            claimsInfo: '',
            claimsInfo1: '',
            despInfo: '',
            despInfo1: '',
            transList: [],
            transList1: [],
            id: '',
            id1: '',
            tempData: [],
            tempData1:[],
            tempData2:[],
            tempData3: [],
            tempItem: [],
            taskId: '',
            timer: '',
            proNum: 0,
            switch1: false,
            switchName: '关闭',
            doubleId: '',
            viewId: '',
            visible: false,
            visible1: false,
            fullscreen1: false,
            detailInfo2: '',
            src: '',
            src1: '',
            transHeader: [
                {
                    text: '执行时间',
                    align: 'start',
                    sortable: false,
                    value: 'executeDate'
                },
                {
                    text: '类型',
                    align: 'start',
                    sortable: false,
                    value: 'type'
                },
                {
                    text: '内容',
                    align: 'start',
                    sortable: false,
                    value: 'content'
                },
            ],
            loading: false,
            claimsInfo3: '',
            despInfo2: '',
            transList2: [],
            zhuluKey: [],
            single: false,
            src2: '',
            src3: '',
            loading1: false,
            lawList: [],
            absolute: true,
            patentId: ''
        }
    },
    computed: {
        isShow() {
            if(this.$vuetify.breakpoint.name=='sm' || this.$vuetify.breakpoint.name == 'xs') {
                return false
            }else {
                return true
            }    
        }
    },
    watch: {
        switch1(val) {
            if(val) {
                this.switchName = '开启'
            }else {
                this.switchName = '关闭'
            }
        },
        zlKey(val) {
            if(val == '1') {
                this.zlContent = '公开号、标题、摘要、申请人、公开日、申请号、发明人'
            }
            if(val == '2') {
                this.zlContent = '公开号、标题、摘要、申请人、专利类型、法律状态、摘要附图、主分类、专利权人、发明人、代理机构'
            }
        },
        showList(val) {
            this.tables = val.tables
            console.log(val.tables,'======val.tables=====')
            this.imageText = val.imageText
            this.fullText = val.fullText
        },
        tables(val) {
            console.log(val,'===val====')
            if(val) {
                let list = []
                this.data.forEach((item)=> {
                    if(this.selectKeys.length>0) {
                        if(this.selectKeys.indexOf(item.id)>-1) {
                            list.push(item)
                        }
                    }
                })
                if(list.length>0) {
                    this.selectedItem = list
                }
            }else {
                this.selectedItem = []
            }
        },
        selectKeys(val) {
            if(val.length>= this.ids.length) {
               this.selAll = true
               this.isIndeter = false
            }else if( val.length>0) {
                this.isIndeter = true
            }else {
                this.selAll = false
                this.isIndeter = false
            }
            this.$emit('getSelectKeys', val)
            let tempItem = []
            this.tempData.forEach((item)=>{
                if(val.indexOf(item.id)>-1) {
                    if(tempItem.length>0) {
                        let flag = false
                        tempItem.forEach((item1)=>{
                            if(item1.id == item.id) {
                                flag = true
                            }
                        })
                        if(!flag) {
                            tempItem.push(item)
                        }
                    }else {
                        tempItem.push(item)
                    }
                }
            }) 
            this.tempItem =  tempItem
        },
        selAll(val) {
            if(val) {
                this.selectKeys = this.ids
            }else {
                this.selectKeys = []
            }
        },
        selAll1(val) {
            if(val) {
                this.selectKeys = this.ids
            }else {
                this.selectKeys = []
            }
        },
        result(val) {
            this.selectKeys = []
            this.tempData1 = this.tempData1.concat(val['list1'])
            // this.tempData1.concat(val['list1'])
            this.tempData2 = this.tempData2.concat(val['list2'])
            // this.tempData2.concat(val['list2'])
            this.tempData3 = this.tempData3.concat(val['list3'])
            // this.tempData3.concat(val['list3'])
            let ids1 = []
            let ids2 = []
            let ids3 = []
            if(val['list1'].length>0) {
                val['list1'].forEach((item)=>{
                    ids1.push(item.id)
                })  
            }
            if(val['list2'].length>0) {
                val['list2'].forEach((item)=>{
                    ids2.push(item.id)
                })  
            }
             if(val['list3'].length>0) {
                val['list3'].forEach((item)=>{
                    ids3.push(item.id)
                })  
            }
            //  this.ids = ids
            this.data = val
            this.data1 = val['list1']
            this.data2 = val['list2']
            this.data3 = val['list3']
            this.tables? this.tempData = this.tempData1: this.imageText? this.tempData = this.tempData2: this.fullText? this.tempData = this.tempData3: this.tempData = []
            this.tables? this.ids = ids1: this.imageText? this.ids = ids2: this.fullText? this.ids = ids3: this.ids = []
        },
        selectedItem(val) {
            let list = []
            if(val.length>0) {
                list = val.map((item)=>{
                    return item.id
                })
                this.selectKeys = list
            }else {
                this.selectKeys = []
            }
        }
    },
    mounted() {
        this.tables = this.showList.tables
        this.imageText = this.showList.imageText
        this.fullText = this.showList.fullText
    },
    methods: {                     
         ...mapActions('search',['getPatentInfo','getPatentClaims','getPatentDesp','getPatentTransAction','getMultiplePdf',
         'getTaskProgress','getWriteFile','getPdfDown','getPatentPdf']),
         
        getSelectKeys(val) {
            console.log('val', val)
        },
        // goDetail1(val) {
        //     this.$router.push({
        //         path: '/search/patentInfo/'+ val,
        //     })
        // },
         //专利跳转详情页面重开新页面
            goDetail1(id) {
          let routeUrl = this.$router.resolve({
          path: '/search/patentInfo/' + id,
        // query: {
        //   from: 'space',
        // },
      })
      window.open(routeUrl.href, '_blank')
    },
                  

        querySearch(val1,val2) {
        console.log(val1,'==val1===')
            let val = val1 + '"' + val2 + '"'
            this.$router.replace('?str='+ val)
            this.$store.commit('setSearchKey', val)
            this.$emit('getKey1', val)
        },
        delSelected(index) {
            this.selectKeys.splice(index,1)
            let list = []
            if(this.selectKeys.length>0) {
                this.data.forEach((item)=> {
                    if(this.selectKeys.length>0) {
                        if(this.selectKeys.indexOf(item.id)>-1) {
                            list.push(item)
                        }
                    }
                })
            }else {
                this.selectedItem = []
            }
            if(list.length>0) {
                this.selectedItem = list
            }
        },
        clearSeleted() {
            this.selectedItem = []
            this.selectKeys = []
        },
        pdfDown() {
            this.pdfDialog = true
            if(this.selectKeys.length>0) {
                this.scopeType = '0'
            }
        },
        handlepdfOk() {
            let udns = ''
            let data = {}
            if(this.scopeType == '0') {
                udns = this.selectKeys.join(',')
                data = {
                    params: {
                        scopeType: this.scopeType,
                        udns: udns,
                        start: -1,
                        end: 0
                        // start: range.start,
                        // end: range.end
                    }
                }
            }
            if(this.scopeType == '1') {
                data.params = this.allFilter
                data.params.scopeType = this.scopeType
                data.params.start = this.pdfRange.split('-')[0]
                data.params.end = this.pdfRange.split('-')[1]
                data.params.udns = ''
            }
            let _this = this
            this.getMultiplePdf({data: data,handle(res) {
                if(res.success) {
                   _this.taskId = res.taskId
                   _this.getProgress()
                }
            }})
        },
        getProgress() {
            let data = {
                id: this.taskId,
                data1: {
                    params: {
                        taskId: this.taskId
                    }
                }
            }
            let _this = this
            this.pdfProgress = true
            this.getTaskProgress({data: data,handle(res) {
                let message = JSON.parse(res.message)
                this.proNum = message.progress
                console.log('message', message)
            }})
            this.timer = setInterval(()=>{
                this.getTaskProgress({data: data,handle(res) { 
                    let message = JSON.parse(res.message)
                    console.log('message', message)
                    _this.proNum = message.progress
                    if(message.status == 'FINISH') {
                        clearInterval(_this.timer)
                        let path = message.filePath
                        _this.pdfProgress = false
                        window.location.href = _this.$store.state.baseUrl + '/export/download?path='+ path
                    }
                }})
            },3000)
            
        },
        handlepdfCancel() {
             this.pdfDialog = false
        },
        zhuluDown() {
            this.single = false
            this.zlDialog = true
            if(this.selectKeys.length>0) {
                this.pdfRangeKey = '0'
            }
        },
        handlezlCancel() {
            this.zlDialog = false
        },
        handlezlOk() {
            let _this = this
            let param = this.allFilter
            let udns = ''
            param.fileType = this.formatKey
            param.templateId = this.zlKey
            param.downloadPdf = this.switch1?1: 0
            param.emails = ''
            param.type = 'download'
            param.wfId = ''
            param.opt = 1
            if(this.pdfRangeKey == '0') {
                udns = this.selectKeys.join(',') 
                if(this.single) {
                  udns = this.zhuluKey.join(',')
                }
                param.scopeType = this.pdfRangeKey
                param.udns = udns
                param.start = -1
                param.end = 0
            }
            if(this.pdfRangeKey == '1') {
                param.scopeType = this.pdfRangeKey
                param.start = this.zlRange.r1
                param.end = this.zlRange.r2
                param.udns = ''
                param.m = ''
                param.cleantc = true
            }
            let data ={
                params: param
            }
            this.getWriteFile({data: data,handle(res) {
                if(res.success) {
                    _this.taskId = res.taskId
                    _this.pdfProgress = true 
                    _this.getProgress()
                }
            }})
        },
        compare() {
            console.log('this.tempItem', this.tempItem)
            this.compDialog = true
            this.activeKey = 0
            this.activeKey1 = 0
            this.id = this.tempItem[0].id
            this.id1 = this.tempItem[0].id
            // this.selectedItem[0].id 
            this.getDetail('1')
            this.getDetail('2')
        },
        handleCompCancel() {
            this.compDialog = false
        },
        selChange(val) {
            this.activeKey = 0
            this.id = val
            this.getDetail('1')
        },
        selChange1(val) {
            this.activeKey1 = 0
            this.id1 = val
            this.getDetail('2')
        },
        initNumber() {
            if(this.compareName) {
                this.id = this.compareName
                this.getDetail('1')
            }
        },
        initNumber1() {
            if(this.compareName1) {
                this.id1 = this.compareName1
                this.getDetail('2')
            }
        },
        activeChange(val) {
            console.log('val-active', val)
            if(val == '0') {
                this.getDetail('1')
            }
            if(val == '1') {
                this.getClaims('1')
            }
            if(val == '2') {
                this.getDesp('1')
            }
            if(val == '3') {
                this.getPdf('1')
            }
            if(val == '4') {
                this.getTransAction('1')
            }
        },
        activeChange1(val) {
            console.log('val-active1', val)
            if(val == '0') {
                this.getDetail('2')
            }
            if(val == '1') {
                this.getClaims('2')
            }
            if(val == '2') {
                this.getDesp('2')
            }
            if(val == '3') {
                this.getPdf('2')
            }
            if(val == '4') {
                this.getTransAction('2')
            }
        },
        getDetail(type) {
            let val = ''
            if(type == '1') {
                val = this.id
            }else {
                val = this.id1
            }
            let data = {
                params: {
                    udn: val
                }
            }
            let _this = this
            this.getPatentInfo({data: data,handle(res) {
                    let info = res.patent ? res.patent: {}
                    if(type == '1') {
                        _this.detailInfo = info
                    }
                    if(type == '2') {
                        _this.detailInfo1 = info
                    }    
            }})
        },
        getClaims(type) {
            let val = ''
            if(type == '1') {
                val = this.id
            }else if(type == '2') {
                val = this.id1
            }else if(type == '3') {
                val = this.doubleId
            }
            let data = {
                params: {
                   udn: val 
                }
            }
            let _this = this
            this.getPatentClaims({data: data,handle(res) {
                if(type == '1') {
                    _this.claimsInfo = res.patent.claims
                }
                if(type == '2') {
                    _this.claimsInfo1 = res.patent.claims
                }
                if(type == '3') {
                    _this.claimsInfo3 = res.patent.claims
                }
            }})
        },
        getDesp(type) {
            let val = ''
            if(type == '1') {
                val = this.id
            }else if(type =='2'){
                val = this.id1
            }else if( type == '3') {
                val = this.doubleId
            }
            let data = {
                params: {
                   udn: val
                }
            }
            let _this = this
            this.getPatentDesp({data: data,handle(res) {
                if(type == '1') {
                    _this.despInfo = res.patent.description
                }
                if(type == '2') {
                    _this.despInfo1 = res.patent.description
                }
                if(type == '3') {
                    _this.despInfo2 = res.patent.description
                }
            }})
        },
        getTransAction(type) {
            let val = ''
            if(type == '1') {
                val = this.id
            }else if(type == '2'){
                val = this.id1
            }else if( type == '3') {
                val = this.doubleId
            }
            let data = {
                params: {
                   udn: val
                }
            }
            this.loading = true
            let _this = this
            this.getPatentTransAction({data: data,handle(res) {
                _this.loading = false
                if(type == '1') {
                    _this.transList = res.txs
                }
                if(type == '2') {
                    _this.transList1 = res.txs
                }
                if(type == '3') {
                    _this.transList2 = res.txs
                }
            }})
        },
        getPdfFile(val) {
            let data = {
                url: val,
                data1: {
                    params: {
                        t: 0
                    }
                }
            }
            let _this = this
            this.getPdfDown({data: data,handle(res) {
                let fp = res.fp
                window.location.href = _this.$store.state.baseUrl + '/export/download?path='+ fp
            }})
        },
      //PDR
        pdfView(val) {
            this.viewId = val
            this.visible = true
            this.getPdf()
        },
        getPdf(type) {
            let id = this.viewId 
            if(type == '1') {
                id = this.id
            }
            if(type == '2') {
                id = this.id1
            }
            if(type == '3') {
                id = this.doubleId 
            }
            let data = {
                params: {
                   udn: id 
                }
            }
            let _this = this
            this.getPatentPdf({data: data,handle(res) {
                _this.src1 = res.pdf.pdfPath
                _this.src = _this.$store.state.baseUrl + res.pdf.pdfPath
                if(type == '1') {
                    _this.src2 = _this.$store.state.baseUrl + res.pdf.pdfPath
                }
                if(type == '2') {
                    _this.src3 = _this.$store.state.baseUrl + res.pdf.pdfPath
                }
            }})
        },
        doubleSreen(val) {
            this.doubleId = val
            this.visible1 = true
            this.getDetail1(val)
        },
        getDetail1(val) {
             let data = {
                params: {
                    udn: val
                }
            }
            let _this = this
            this.getPatentInfo({data: data,handle(res) {
                    let info = res.patent ? res.patent: {}
            }})
        },
        handleChange1(val) {
            console.log('val', val)
            if(val ==2 && !this.claimsInfo) {
                this.getClaims('3')
            }
            if(val ==3 && !this.despInfo) {
                this.getDesp('3')
            }
            if(val == 4) {
                this.getPdf('3')
            }
            if(val ==5) {
                this.getTransAction('3')
            }
        },
        zhulDown(val) {
            this.single = true
            this.zlDialog = true
            this.zhuluKey = [val]
            this.pdfRangeKey = '0'
        },
        getInfo1(val) {
            if(this.patentId == val) {
                return false
            }else {
                this.patentId = val
                this.getTransAction1(val)
            }
        },
        getTransAction1(id) {
            this.loading1 = true
            let data = {
                params: {
                   udn: id 
                }
            }
            let _this = this
            this.getPatentTransAction({data: data,handle(res) {
                console.log(res)
                _this.loading1 = false
                _this.lawList = res.txs
            }})
        },
         goDetail(val,items) {
           
            let id = items.item.id
            this.$router.push({
                path: '/search/patentInfo/'+ id,
            })
        },
        addSpaceEvent(val) {
            this.$emit('spaceInfoChange', val)
        },
        goLike(val) {
            console.log('val', val)
            let id = val.id
            let url = this.$router.resolve({
                path: '/search/patentInfo/'+ id,
                query: {
                    'tab': 'like'
                }
            })
            window.open(url.href,'_blank')
        }
    }
}
</script>
